var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"custom-container"},[_c('img',{staticClass:"gear-image",attrs:{"src":"/media/handShake.png"}}),_c('div',{staticClass:"gear"}),_c('h1',{staticClass:"gear-text"},[_vm._v("لطفا صبر کنید در حال انتقال به صفحه اصلی...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }